import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const addressLookupComponent = Loadable(() => import('../containers/AddressLookup'));
export default MapTo('vcg/components/soe-home/react/retail/AddressLookup')(addressLookupComponent);
